export default "__VITE_ASSET__BTl5vi8a__"